import { PaginationMeta } from '../../../models/pagination-meta.model';

export interface AdminPaginationState {
  searchTerm: string;
  /** Role filter for admin users list: 'all' | 'admin' | 'user'. */
  roleFilter?: 'all' | 'admin' | 'user';
  /** Active filter for admin users list: 'all' | 'active' | 'inactive'. */
  activeFilter?: 'all' | 'active' | 'inactive';
  /** Owner user IDs for admin mail accounts list (filter by owner). */
  ownerIds?: number[];
  currentPage: number;
  lastPage: number;
  perPage: number;
  total: number;
}

export function buildAdminListQuery(state: AdminPaginationState): {
  paginated: true;
  search?: string;
  role?: 'admin' | 'user';
  active?: boolean;
  all?: boolean;
  ownerIds?: number[];
  page: number;
  perPage: number;
} {
  const query: {
    paginated: true;
    search?: string;
    role?: 'admin' | 'user';
    active?: boolean;
    all?: boolean;
    ownerIds?: number[];
    page: number;
    perPage: number;
  } = {
    paginated: true,
    page: state.currentPage,
    perPage: state.perPage,
  };
  if (state.searchTerm?.trim()) {
    query.search = state.searchTerm.trim();
  }
  if (state.roleFilter && state.roleFilter !== 'all') {
    query.role = state.roleFilter;
  }
  if (state.activeFilter === 'all') {
    query.all = true;
  } else if (state.activeFilter === 'active') {
    query.active = true;
  } else if (state.activeFilter === 'inactive') {
    query.all = true;
    query.active = false;
  }
  if (state.ownerIds?.length) {
    query.ownerIds = state.ownerIds;
  }
  return query;
}

export function applyAdminPageMeta(
  state: AdminPaginationState,
  meta: PaginationMeta | null,
  dataLength: number,
): void {
  state.currentPage = meta?.current_page ?? state.currentPage;
  state.lastPage = meta?.last_page ?? 1;
  state.total = meta?.total ?? dataLength;
}

export function moveToNextAdminPage(state: AdminPaginationState): boolean {
  if (state.currentPage >= state.lastPage) {
    return false;
  }
  state.currentPage++;
  return true;
}

export function moveToPreviousAdminPage(state: AdminPaginationState): boolean {
  if (state.currentPage <= 1) {
    return false;
  }
  state.currentPage--;
  return true;
}

export function resetAdminPagination(state: AdminPaginationState): void {
  state.currentPage = 1;
}

export function moveToPreviousPageAfterDelete(state: AdminPaginationState, remainingItems: number): boolean {
  state.total = Math.max(0, state.total - 1);
  if (remainingItems === 0 && state.currentPage > 1) {
    state.currentPage--;
    return true;
  }
  return false;
}
